module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/id/6-e75fff1918bfe5ff87d40847dc5db975.jpg";